import {Tooltip, useTheme} from '@mui/material';
import Grid from '@mui/material/Grid';

import {REPORT_PARAMETERS_ACCORDIONS_IDS, REPORT_UPDATE_HISTORY_STATUSES} from '../../../../const';
import usePayment from '../../../../hooks/providers/usePayment';
import useReportParameters from '../../../../hooks/providers/useReportParameters';
import {getHumanReadableTimeElapsedFromDate} from '../../../../utils';
import CategoryAccordion from '../../shared/CategoryAccordion/CategoryAccordion';
import CategoryAccordionIcon from '../../shared/CategoryAccordionIcon/CategoryAccordionIcon';
import Histories from '../history/Histories/Histories';
import UpdateInProgressBlock from '../history/UpdateInProgressBlock/UpdateInProgressBlock';
import UpdateButton from '../instant-update/UpdateButton/UpdateButton';
import PlannedUpdateBanner from '../planned-update/PlannedUpdateBanner/PlannedUpdateBanner';
import PlannedUpdateButton from '../planned-update/PlannedUpdateButton/PlannedUpdateButton';
import PlannedUpdateModal from '../planned-update/PlannedUpdateModal/PlannedUpdateModal';

const SUCCESS_CONFIG = muiTheme => ({
  title: 'Mises à jour',
  icon: 'Check',
  iconColor: muiTheme.palette.success.main,
  backgroundColor: 'white',
  borderColor: '#DEDEDE'
});

const getUpdateHistoryStatusConfig = muiTheme => ({
  [REPORT_UPDATE_HISTORY_STATUSES.COMPLETED]: SUCCESS_CONFIG(muiTheme),
  [REPORT_UPDATE_HISTORY_STATUSES.REGISTERED]: SUCCESS_CONFIG(muiTheme),
  [REPORT_UPDATE_HISTORY_STATUSES.CANCELLED]: SUCCESS_CONFIG(muiTheme),

  [REPORT_UPDATE_HISTORY_STATUSES.FAILED]: {
    title: 'Dernière actualisation échouée',
    icon: 'Warning',
    iconColor: '#c98a04',
    backgroundColor: '#FEFCEA',
    borderColor: '#FDE68A'
  }
});

const Updates = () => {
  const theme = useTheme();
  const {shortRefreshesHistory, areAllSourcesConnected, hasPlannedUpdate, setReportParametersCategoryExpanded, runDatasetRefresh, reportParametersCategoryExpanded, isDatasetCurrentlyRefreshing} =
    useReportParameters();
  const {isGuest} = usePayment();

  const lastHistory = shortRefreshesHistory[0];
  const subtitle = lastHistory ? `Dernière actualisation: ${getHumanReadableTimeElapsedFromDate(lastHistory.endTime)}` : null;
  const isExpanded = reportParametersCategoryExpanded === REPORT_PARAMETERS_ACCORDIONS_IDS.UPDATES;

  const lastHistoryStylesConfig = getUpdateHistoryStatusConfig(theme)[lastHistory?.status] || getUpdateHistoryStatusConfig(theme)[REPORT_UPDATE_HISTORY_STATUSES.COMPLETED];

  const {title, icon, iconColor, backgroundColor, borderColor} = lastHistoryStylesConfig;

  const handleUpdateButtonClick = e => {
    e.stopPropagation();
    setReportParametersCategoryExpanded(REPORT_PARAMETERS_ACCORDIONS_IDS.UPDATES);
    runDatasetRefresh();
  };

  const isUpdating = isDatasetCurrentlyRefreshing();
  const tooltipText = areAllSourcesConnected
    ? ''
    : isGuest
    ? 'Veuillez contacter un administrateur pour connecter les sources des données'
    : 'Veuillez connecter vos sources de données avant de lancer une actualisation';

  const renderActionsSection = () => {
    return (
      <Grid item mr={1}>
        <Tooltip data-testid="buttons-tooltip" title={tooltipText}>
          <Grid container alignItems="center" gap={1.5}>
            <PlannedUpdateButton />
            <UpdateButton isUpdating={isUpdating} onUpdateNowButton={handleUpdateButtonClick} />
          </Grid>
        </Tooltip>
      </Grid>
    );
  };

  return (
    <CategoryAccordion
      sx={{
        '& .MuiAccordionSummary-root': {
          borderColor,
          backgroundColor
        }
      }}
      disabled={shortRefreshesHistory.length === 0 && !hasPlannedUpdate}
      id={REPORT_PARAMETERS_ACCORDIONS_IDS.UPDATES}
      icon={<CategoryAccordionIcon iconName={icon} color={iconColor} />}
      title={title}
      subtitle={subtitle}
      expanded={isExpanded}
      renderActionsSection={renderActionsSection}
    >
      <PlannedUpdateBanner />
      {isUpdating && <UpdateInProgressBlock />}
      <Histories />
      <PlannedUpdateModal />
    </CategoryAccordion>
  );
};

export default Updates;
